export default __webpack_public_path__ + "static/media/kin-home-bg.5c14af22.jpeg";